(function () {
  if (!document.body.hasAttribute('pt-1-ab-test')) return;

  function hideUpgradeButton(root) {
    if (root.querySelector('style[data-pt-1-ab-test]')) return true;
    var style = document.createElement('style');
    style.setAttribute('data-pt-1-ab-test', '');
    style.textContent = '.opus-subscription-upgrade-btn { display: none !important; }';
    root.appendChild(style);
    return true;
  }

  function inject() {
    var host = document.getElementById('opus-shadow-container');
    if (!host || !host.shadowRoot) return false;
    return hideUpgradeButton(host.shadowRoot);
  }

  if (inject()) return;

  var observer = new MutationObserver(function () {
    if (inject()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
